import instituteSelector from 'modules/Auth/selectors'
import { systemConfig } from 'utils/config.js'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import elasticSearchSyncRequest from 'utils/elasticSearchSyncRequest'
import ErrorMessage from 'utils/ErrorMessage'
import instRequest from 'utils/instRequest'

export const SET_INSTITUTE_DATA = 'SET_INSTITUTE_DATA'
export const SET_UNIVERSITY_LIST = 'SET_UNIVERSITY_LIST'

export const setInstituteData = list => {
  return {
    type: SET_INSTITUTE_DATA,
    list,
  }
}

export const setUniversityList = list => {
  return {
    type: SET_UNIVERSITY_LIST,
    list,
  }
}

export const getInstituteInfo = () => async (dispatch, getState) => {
  const state = getState()

  try {
    let resp = await instRequest.get(
      `/institutes/instituteCampus/${state?.auth?.instituteDetails?.id}`
    )
    dispatch(setInstituteData(resp?.data?.data))
    return resp?.data?.data
  } catch (error) {
    console.error('Getting error in user data', error)
  }
}

export const updateInstituteInfos = payload => async (dispatch, getState) => {
  const state = getState()
  const instituteCampusId = instituteSelector.getInstituteDetails(state).id
  try {
    let response = await instRequest.put(
      `/institutes/instituteCampus/${instituteCampusId}`,
      payload
    )

    function formatDate(date) {
      let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    }

    let payloadData = {
      query_date: formatDate(new Date()), // This will format today's date as "yyyy-mm-dd"
    }

    await elasticSearchSyncRequest.post(`/sync/institutes_master`, payloadData)
    dispatch(getInstituteInfo())
    return response
  } catch (error) {
    console.error('Getting error in updating corporate data', error)
    ErrorMessage(error?.response?.data?.message)
    return error
  }
}

export const getUniversityList = searchValue => async (dispatch, getState) => {
  let payload = systemConfig?.universities
  payload.q = searchValue || ''
  try {
    const result = await elasticSearchRequest.post(
      `/search/universities`,
      payload
    )
    let data = result.data.data?.hits?.hits?.map(item => item._source)
    dispatch(setUniversityList(data))
    return result
  } catch (error) {
    ErrorMessage(error?.message)
    dispatch(setUniversityList({}))
  }
}

export const getMasterSearchApi = (type, payload) => async () => {
  {
    //console.log(payload, 'searchData')
  }
  try {
    let response
    let result

    if (type === 'skills') {
      const response = await elasticSearchRequest.get('/students/crud/skill', {
        params: {
          page: 0,
          pageLimit: 10000,
          search: payload?.q,
          isActive: true,
          status: 1,
          order: 'asc',
        },
      })
      //console.log(response, 'response')
      result = response?.data?.data?.result || []
    } else {
      const response = await elasticSearchRequest.post(
        `/search/${type}`,
        payload
      )
      result = response.data.data?.hits?.hits?.map(item => item._source)
    }
    //console.log(response, 'elseresponse')
    return result
  } catch (error) {
    ErrorMessage(error?.message || 'Search failed')
    return []
  }
}
